function createShopifyProductFromFirstDiamond(button) {
  var diamond = button.dataset;
  const {
    shape,
    size,
    color,
    clarity,
    cut,
    symmetry,
    polish,
    depth_percent,
    table_percent,
    meas_width,
    meas_depth,
    meas_length,
    fluor_color,
    fluor_intensity,
    price,
    lab,
    cert_num,
    image_file_url,
    video_url,
  } = diamond;
  showRedirectMessage(shape);
  const fiyat = price * dxCurrency; // Fiyat çarpanlı
  const carat = size;
  const sertifikaNo = cert_num;
  let certUrl;
    if (lab === 'GIA') {
        certUrl = `https://www.gia.edu/report-check?reportno=${cert_num}`
    } else if (lab === 'HRD') {
        certUrl = 'https://my.hrdantwerp.com/'
    } else {
        certUrl = `https://www.gia.edu/report-check?reportno=${cert_num}`
    }
  switch (shape) {
          case "Yuvarlak":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Yuvarlak_real.png?v=1722519355';
                break;
            case "Oval":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/oval_real.png?v=1722519356';
                break
            case "Kalp":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Kalp_real.png?v=1722519355';
                break;
            case "Damla":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Damla_real.png?v=1722519355';
                break;
            case "Radiant":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/5da16146-264a-468c-a916-7116bf339f0f.png?v=1748850658';
                break;
            case "Emerald":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Emerald_real.png?v=1722519355';
                break;
            case "Markiz":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Markiz_real.png?v=1722519355';
                break;
            case "Cushion":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Cushion_real.png?v=1722519356';
                break;
            case "Prenses":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Prenses_real.png?v=1722519355';
                break;
            default:
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Yuvarlak_real.png?v=1722519355'; // Varsayılan bir değer ekleyebilirsin
      }
  
  const selectedImageUrl = [{ src: imageUrl }];
  const aciklama = `<ul>
                      <li>Pırlanta Şekli: ${shape}</li> 
                      <li>Karat: ${carat}</li>
                      <li>Renk: ${color}</li>
                      <li>Berraklık: ${clarity}</li>
                      <li>Sertifika Laboratuvarı: ${lab}</li>
                      <li>Sertifika No: ${cert_num}</li>
                      <li>Kesim: ${cut ? cut : '-'}</li>
                      <li>Simetri: ${symmetry}</li>
                      <li>Parlaklık: ${polish}</li>
                      <li>Floresan Rengi: ${fluor_color}</li>
                      <li>Floresan: ${fluor_intensity}</li>
                      <li>Derinlik Oranı: ${depth_percent}</li>
                      <li>Tabla Oranı: ${table_percent}</li>
                      <li>Taşın Eni: ${meas_width}</li>
                      <li>Taşın Derinliği: ${meas_depth}</li>
                      <li>Taşın Uzunluğu: ${meas_length}</li>
                      </ul>
                      <a style="text-decoration: underline;" href="${certUrl}" target="_blank">Sertifikayi Görüntüle</a>`; // Açıklama
  // Shopify için POST isteği yap
  const tasDetayi = shape + " / " + carat + " ct" + " | " +
      "Renk: " + color + " | " +
      "Berraklık:" + clarity + " | " +
      "Sertifika:" + lab + "-" + cert_num;
  fetch("https://fair-column-449114-n6.oa.r.appspot.com/create-product-new", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      title: "Gabriano " + sertifikaNo, // Ürün adı olarak sertifika no
      body_html: aciklama, // Açıklama
      vendor: "Gabriano Diamond", // Satıcı
      product_type: "Montürlü Taş", // Ürün tipi
      variants: [
        {
          option1: shape,
          price: fiyat, // Fiyat
          sku: sertifikaNo, // SKU olarak sertifika no
          barcode: price,
          tracked: true,
          inventory_quantity: 1,
        },
      ],
      options: [
        {
          name: "Pırlanta Şekli",
        },
      ],
      images: selectedImageUrl, // Resim URL'si
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      const propertyNames = Object.entries(data);
      console.log(
        "Ürün başarıyla oluşturuldu:",
        propertyNames[1][1].variants[0]
      );
      const variantId = propertyNames[1][1].variants[0].id; // Ürünün variant ID'sini al
      const tasDetayiData = {
        shape: shape,
        fiyat: fiyat,
        tasDetayi: tasDetayi,
        variantId: variantId
      };
      document.cookie = "diamondDetails=" + encodeURIComponent(JSON.stringify(tasDetayiData)) + ";path=/";
      
      console.log("Ürün bilgileri çerezlere kaydedildi:", tasDetayiData);
      setTimeout(function() {hideLoadingAnimation(); window.location.href = `/collections/tektas-yuzuk?filter.p.m.mycustom.suitable_diamond=${shape}`;}, 1500);
      
    })
    .catch((error) => console.error("Ürün oluştururken hata:", error));
}

function addShopifyDiamondtoInput(button) {
  
  var diamond = button.dataset;

  const {
    shape,
    size,
    color,
    clarity,
    cut,
    symmetry,
    polish,
    depth_percent,
    table_percent,
    meas_width,
    meas_depth,
    meas_length,
    fluor_color,
    fluor_intensity,
    price,
    lab,
    cert_num,
    image_file_url,
    video_url,
  } = diamond;

  const fiyat = price * dxCurrency; // Fiyat çarpanlı
  const sertifikaNo = cert_num;
  const carat = size;
  switch (shape) {
          case "Yuvarlak":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Yuvarlak_real.png?v=1722519355';
                break;
            case "Oval":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/oval_real.png?v=1722519356';
                break
            case "Kalp":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Kalp_real.png?v=1722519355';
                break;
            case "Damla":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Damla_real.png?v=1722519355';
                break;
            case "Radiant":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/5da16146-264a-468c-a916-7116bf339f0f.png?v=1748850658';
                break;
            case "Emerald":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Emerald_real.png?v=1722519355';
                break;
            case "Markiz":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Markiz_real.png?v=1722519355';
                break;
            case "Cushion":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Cushion_real.png?v=1722519356';
                break;
            case "Prenses":
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Prenses_real.png?v=1722519355';
                break;
            default:
                imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Yuvarlak_real.png?v=1722519355'; // Varsayılan bir değer ekleyebilirsin
  }
  const selectedImageUrl = [{ src: imageUrl }];
  const aciklama = `<ul>
                      <li>Pırlanta Şekli: ${shape}</li> 
                      <li>Karat: ${carat}</li>
                      <li>Renk: ${color}</li>
                      <li>Berraklık: ${clarity}</li>
                      <li>Sertifika Laboratuvarı: ${lab}</li>
                      <li>Sertifika No: ${cert_num}</li>
                      <li>Kesim: ${cut ? cut : '-'}</li>
                      <li>Simetri: ${symmetry}</li>
                      <li>Parlaklık: ${polish}</li>
                      <li>Floresan Rengi: ${fluor_color}</li>
                      <li>Floresan: ${fluor_intensity}</li>
                      <li>Derinlik Oranı: ${depth_percent}</li>
                      <li>Tabla Oranı: ${table_percent}</li>
                      <li>Taşın Eni: ${meas_width}</li>
                      <li>Taşın Derinliği: ${meas_depth}</li>
                      <li>Taşın Uzunluğu: ${meas_length}</li>
                      </ul>`; // Açıklama
    var dxCloseButton = document.querySelector(
        "[data-cus-diamond-popup-close]"
    );
  dxCloseButton.click();
  showLoadingAnimation();

  // Shopify için POST isteği yap
  fetch("https://fair-column-449114-n6.oa.r.appspot.com/create-product-new", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      title: "Gabriano " + sertifikaNo, // Ürün adı olarak sertifika no
      body_html: aciklama, // Açıklama
      vendor: "Gabriano Diamond", // Satıcı
      product_type: "Montürlü Taş", // Ürün tipi
      variants: [
        {
          option1: shape,
          option2: carat,
          price: fiyat, // Fiyat
          sku: sertifikaNo, // SKU olarak sertifika no
          barcode: price,
          tracked: true,
          inventory_quantity: 1,
        },
      ],
      images: selectedImageUrl, // Resim URL'si
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      const propertyNames = Object.entries(data);
      console.log(
        "Ürün başarıyla oluşturuldu:",
        propertyNames[1][1].variants[0]
      );
      hideLoadingAnimation();
      if (dxPirlantaProductInput) {
        dxPirlantaProductInput.value = propertyNames[1][1].variants[0].id;
      }
      var content = propertyNames[1][1].variants[0].title + " / " + carat + " ct" + " | " +
      "<b>Renk:</b> " + color + " | " +
      "<b>Berraklık:</b> " + clarity + " | " +
      "<b>Sertifika:</b> " + lab + "-" + sertifikaNo;

      var content2 = propertyNames[1][1].variants[0].title + " / " + carat + " ct" + " | " +
      "Renk: " + color + " | " +
      "Berraklık:" + clarity + " | " +
      "Sertifika:" + lab + "-" + sertifikaNo;
      
      if (dxPirlantaPropertiesInput) {
        dxPirlantaPropertiesInput.value  = propertyNames[1][1].variants[0].id;
        dxPirlantaPropertiesInput2.value = content2;
      }
      const variantId = propertyNames[1][1].variants[0].id; // Ürünün variant ID'sini al
      const tasDetayiData = {
        shape: shape,
        fiyat: fiyat,
        tasDetayi: content2,
        variantId: variantId
      };
      document.cookie = "diamondDetails=" + encodeURIComponent(JSON.stringify(tasDetayiData)) + ";path=/";
      if (dxProductPageDiamondHolder) {
        var spanElement = dxProductPageDiamondHolder.querySelector("span");
        if (spanElement) {
          spanElement.innerHTML  = content;
        }
      }
      window.scrollTo({ top: previousScrollPosition, behavior: "smooth" });
      document.querySelector(".dx-diamond-popup-content-container").scrollTo({ top: previousScrollPopupPosition, behavior: "smooth" });
      if(dxDiamondPricePlaceHolder){
        dxDiamondPricePlaceHolder.setAttribute('data-dxcalculation-price', fiyat * 100);
      }
      const dxcurrenctProductPrice = document.querySelector('#dxSelectablePrice');
      const dxlastPricewithDiamond = parseInt(dxDiamondPricePlaceHolder.dataset.dxcalculationPrice) + parseInt(dxcurrenctProductPrice.dataset.dxcalculationPrice);
      const installmentPrice = dxlastPricewithDiamond / 3;
      const installmentDisplayElement = document.getElementById('installment-price-display');
      dxcurrenctProductPrice.innerHTML = Shopify.formatMoney(dxlastPricewithDiamond, window.money_format);
      if (installmentDisplayElement) {
          installmentDisplayElement.innerHTML = Shopify.formatMoney(installmentPrice, window.money_format);
        }
    })
    .catch((error) => console.error("Ürün oluştururken hata:", error));
}

function tableAddToCart(productId, properties) {
  var data = {
    items: [
      {
        id: productId,
        quantity: 1,
        properties: properties,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Ürün sepete eklendi:", data);
      // Burada sepete ekleme işlemi başarılı olduğunda yapılacak işlemler eklenebilir.
      // Örneğin, bir onay mesajı gösterilebilir veya kullanıcıyı sepet sayfasına yönlendirebilirsiniz.
    })
    .catch((error) => console.error("Sepete ekleme işlemi başarısız:", error));

  
  setTimeout(function() {
    hideLoadingAnimation();
    window.location.href = '/cart';
  }, 1000); // 200 milisaniye (0.2 saniye)
}

function showLoadingAnimation() {
  // Create loading container
  const loadingContainer = document.createElement("div");
  loadingContainer.className = "dx-spinner-container";
  loadingContainer.innerHTML = '<div class="dx-spinner"></div>';
  document.body.appendChild(loadingContainer);
}

function showRedirectMessage(shape) {
  // Create message container
  const messageContainer = document.createElement("div");
  messageContainer.className = "dx-message-container";
  messageContainer.innerHTML = `<div class="dx-message-container"><div class="dx-message"><h3>Harika Seçim! <span class="dx-shape">"${shape}"</span> Taş Seçiminiz Kayıt Edildi.</h3><p>Taş seklinize uygun yüzük modeli için yüzük sayfasına yönlendiriliyorsunuz.</p></div></div>`;
  document.body.appendChild(messageContainer);
}


function hideLoadingAnimation() {
  // Remove loading container
  const loadingContainer = document.querySelector(".dx-spinner-container");
  if (loadingContainer) {
    document.body.removeChild(loadingContainer);
  }
}